import {NAMES} from "@/scripts/components/ab-data-sheet/ab-data-sheet.constants";

export const getRootLayoutClassList = (
  size: number,
  productsCount: number,
  compareBoxOpened: boolean,
  isSticky: boolean,
): string => {

  const MIN_CELL_WIDTH_FOR_COMPACT_VIEW = 225;
  const LABEL_CELL_WIDTH = 150;

  const requiredWidthForCompactView = LABEL_CELL_WIDTH + (productsCount * MIN_CELL_WIDTH_FOR_COMPACT_VIEW);
  const classList = [NAMES.CSS_CLASSES.ROOT];
  const productCountClass = `${NAMES.CSS_CLASSES.ROOT_PRODUCT_COUNT_PREFIX}-${productsCount}`;
  classList.push(productCountClass);
  if (isSticky) {
    classList.push(NAMES.CSS_CLASSES.ROOT_STICKY);
  }
  if (size >= requiredWidthForCompactView) {
    classList.push(NAMES.CSS_CLASSES.ROOT_LAYOUT_COMPACT);
  }
  if (compareBoxOpened) {
    classList.push(NAMES.CSS_CLASSES.ROOT_COMPARE_BOX_SHOWN);
  }
  return classList.join(' ').trim();
}